const communicationAndLiabilityFields = [
  "liability_request_status",
  "liability_request_email",
  "liability_status",
  "liability_note",
  "coverage_status",
  "coverage_note",
];

const docWithAppointmentFields = [
  "service",
  "price",
  "appointment_date",
  "provider_type",
  "appointment_time",
];

const policyAndMedicalLimitsFields = [
  "policy_limit_selection",
  "individual_policy_limit",
  "incident_policy_limit",
  "umbrella_policy_limit",
  "uninsured_motorist_selection",
  "uninsured_motorist_individual",
  "uninsured_motorist_incident",
  "medical_pay",
  "personal_injury_protection",
];

export const FieldsOrderedList = [
  ...communicationAndLiabilityFields,
  ...policyAndMedicalLimitsFields,
  ...docWithAppointmentFields,
];

export const visibilityControlledFields = [...policyAndMedicalLimitsFields];

export const fullWidthFieldsWithNaNTrigger = [
  "policy_limit_selection",
  "uninsured_motorist_selection",
];

/**
 *TODO: Remove  headerLabelIcon when the backend is ready to provide icons
 */
export const headerLabelIcon = {
  "follow-up-details": "his-calendar-search",
  "communication-&-liability": "his-shield-check",
  "policy-&-medical-limits": "his-dollar-sign",
};
